<div class="page-wrapper">
  <div class="info-container" [class.expanded]="estaExpandido">
    <button class="info-button" (click)="alternarCardInformacoes()">
      <span #spanExpandido [class.expanded-title]="estaExpandido">
        @if (estaExpandido) {
          {{ 'COMPONENTS.DIALOG_INFORMACOES.productivity' | transloco }}
        } @else {
          {{ 'COMPONENTS.DIALOG_INFORMACOES.title' | transloco }}
        }
      </span>
        <img class="expand-icon" [src]="estaExpandido 
            ? 'assets/metas/fechar-dialog.svg' 
            : 'assets/metas/expandir.svg'"

          [alt]="estaExpandido 
            ? ('COMPONENTS.DIALOG_INFORMACOES.title' | transloco) 
            : 'Expandir'"

          [matTooltip]="estaExpandido
            ? ('COMPONENTS.DIALOG_INFORMACOES.collapse_dialog' | transloco)
            : ('COMPONENTS.DIALOG_INFORMACOES.expand_dialog' | transloco)"
        />
    </button>

    <div class="info-content" [class.hidden]="!estaExpandido">
      <div class="info-section">
        @if (loading) {
          <div class="loading-container info-metas">
            <mat-spinner diameter="50"></mat-spinner>
          </div>
        } @else {
          <div class="info-metas">
            <app-produtividade-metas
              [currentValue]="metaAtual"
              [maxValue]="metaMaxima"
              [expectedValue]="metaEsperada">
            </app-produtividade-metas>
          </div>

          <div class="info-turnos">
            <app-produtividade-turnos
              [turnosData]="dadosTurnos">
            </app-produtividade-turnos>
          </div>
        }
      </div>
    </div>

    @if(estaExpandido){
      <div *ngIf="!operacaoSelecionada">
        <h2 class="titulo d-inline">{{ 'COMPONENTS.DIALOG_INFORMACOES.supply_autonomy' | transloco }}</h2>
        <span class="sub-titulo">{{ 'COMPONENTS.DIALOG_INFORMACOES.real_time' | transloco }}</span>
        @if (loading) {
          <div class="loading-container conteudo-container">
            <mat-spinner diameter="50"></mat-spinner>
          </div>
        } @else {
          <div class="conteudo-container" *ngIf="!operacaoSelecionada" [style]="{'max-height': alturaContainerEquipamentosExpandido + 'vh', 'min-height': alturaContainerEquipamentosExpandido + 'vh'}">
            <app-autonomia-insumos
              (expandidoEquipamento)="modificaEquipamentoExpandido($event)"
              [autonomiasInsumos]="autonomiasInsumos"
              [clienteId]="clienteId">
            </app-autonomia-insumos>
          </div>
        }
      </div>

      <div *ngIf="!equipamentoSelecionado">
        <h2 class="titulo">{{ 'COMPONENTS.DIALOG_INFORMACOES.operations' | transloco }}</h2>
        @if (loading) {
          <div class="loading-container info-operacoes">
            <mat-spinner diameter="50"></mat-spinner>
          </div>
        } @else {
          <div class="info-operacoes" *ngIf="!equipamentoSelecionado" [style]="{'max-height': alturaContainerOperacoesExpandido + 'vh', 'min-height': alturaContainerOperacoesExpandido + 'vh'}">
            <app-listar-operacoes
              [idCliente]="clienteId"
              [dataInicio]="dataInicio"
              [dataFim]="dataFim"
              [operacoes]="operacoes"
              (operacaoSelecionadaEvent)="modificaOperacaoSelecionada($event)">
            </app-listar-operacoes>
          </div>
        }
      </div>
    }
  </div>
</div>
